import { gql } from '@apollo/client';

export const QUERY_FETCH_ORDER_LIST = gql`
  query POListFunction($input: POListInput) {
    POListFunction(input: $input) {
      message
      success
      totalCount
      statusCount {
        count
        _id
        _idTranslated
        subStatus
        filteredText
      }
      data
    }
  }
`;

export const QUERY_FETCH_ORDER_LIST2 = gql`
  query POList($input: POListInput) {
    POList(input: $input) {
      message
      success
      totalCount
      data
    }
  }
`;

export const QUERY_FETCH_ORDER_LIST3 = gql`
  query Query($input: JSON) {
    orderList(input: $input)
  }
`;

export const QUERY_FETCH_ORDER_STATUS = gql`
  query POStatus($input: POListInput) {
    POStatus(input: $input) {
      message
      success
      totalCount
      data
    }
  }
`;

export const QUERY_FETCH_ORDER_STATUS2 = gql`
  query Query($input: JSON) {
    orderStatusCount(input: $input)
  }
`;

export const QUERY_FETCH_PARTICIPATION_LIST = gql`
  query Query {
    fetchListofParticipants {
      username
      userid
      orgID
    }
  }
`;
const QUERY_FETCH_STATUS_LIST = gql`
  query POServiceStatusDisplay($input: PoServiceStatusInput!) {
    POServiceStatusDisplay(input: $input) {
      success
      message
      data {
        _id
        count
      }
    }
  }
`;

export const DELETE_ORDERS = gql`
  mutation DeleteOrders($input: deleteInput) {
    DeleteOrders(input: $input)
  }
`;

export const BULKACTION = gql`
  mutation BulkOperation($input: bulkInput) {
    BulkOperation(input: $input) {
      message
    }
  }
`;

export const FETCH_PARTICIPANTS = gql`
  query fetchUserCollab($input: fetchUserCollabInput) {
    FetchUserCollab(input: $input)
  }
`;

export const FETCH_BULK_LINE_ITEMS = gql`
  query ListLineItems($input: ListLineItemsInput) {
    ListLineItems(input: $input) {
      message
      success
      data {
        itemName
        itemCode
        description
        price
        quantity
        grossWeight
        weightUnit
        volumeWeight
        dimensions {
          length
          height
          width
          _id
        }
        discountAmt
        discountPer
        total
        dueDate
        notes
        bookedQty
        cargoQty
        processedQty
        pendingQty
        _id
        statusName
        poID
        poNumber
        cargoReadyDate
      }
    }
  }
`;

export const ADD_PARTICIPANTS = gql`
  mutation AddNewParticipant($input: addNewParticipantInput) {
    addNewParticipant(input: $input)
  }
`;

export const ASSIGN_OWNERS = gql`
  mutation UpdateOwners($input: updateOwnersInput) {
    UpdateOwners(input: $input)
  }
`;

export const TRANSFER_OWNERS = gql`
  mutation TransferOwners($input: transferOwnersInput) {
    TransferOwners(input: $input)
  }
`;

export const CREATE_PO = gql`
  mutation CreatePo($input: CreatePurchaseOrderInput) {
    createPo(input: $input)
  }
`;

export default QUERY_FETCH_STATUS_LIST;
